module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/hairstyle_03@2x-7d371b9df0cac9a3304647e8aea91d95.webp";